<template>
	<sf-content-layout>
		<template v-slot:location>
			<!-- TableInfo locations영역 -->
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<!-- TableInfo title영역(즐겨찾기) -->
			<sf-content-title
				:title="getMessage_(screen.menuTitle)"
				useFaivorite
				:faivorite="screen.favoriteYn === 'Y'"
				:onFavorite="onFavorite"
			/>
		</template>
		<template v-slot:content>
			<!-- TableInfo Content(내용)영역 -->
			<content-view :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
//import ContenteView

import ContentView from './Content/ContentView.vue';

import { serviceComputed, serviceMethods } from '@qms/TableInfo/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: { ContentView },
	async mounted() {
		//this.$sf_toggleLoading(true);
		//await Promise.all([this.select_(), this.getUseYnList_(this.user.plantCd), this.selectOptions_()]);
		this.$sf_toggleLoading(false);
	},
	methods: {
		...serviceMethods,
		...rootMethods,
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	computed: {
		...serviceComputed,
		...rootComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	}
};
</script>

<style></style>
